import axios from '@axios'
import { get } from '@vueuse/core'

const group = 'salary_and_commission/'
const route = 'point_control'

export default {
  namespaced: true,
  state: {
    pointControls: [],
    pointControl: {},
    photoBase64: '',
    employee: {},
    step: '', // select_employee | define_point/ resumo /edit_point
    mode: '', // normal | edit
  },
  getters: {
    getMode: state => state.mode,
    getPointControls: state => state.pointControls,
    getEmployee: state => state.employee,
    getStep: state => state.step,
    getPointControl: state => state.pointControl,

    getPhotoBase64: state => state.photoBase64,
  },
  mutations: {
    setMode(state, mode) {
      state.mode = mode
    },
    setPointControls(state, pointControls) {
      state.pointControls = pointControls
    },
    setEmployee(state, employee) {
      state.employee = employee
    },
    setStep(state, step) {
      state.step = step
    },
    setPointControl(state, pointControl) {
      state.pointControl = pointControl
    },
    setPhotoBase64(state, photoBase64) {
      state.photoBase64 = photoBase64
    },

  },
  actions: {
    index(context, payload) {
      return axios.post(group + route, payload)
    },

    loadEmployees(context, params) {
      return axios.get(`${group + route}/get_employees`, params)
    },

    storePoint(context, params) {
      return axios.post(`${group + route}/store_point`, params)
    },

    // atualizar ponto
    updatePoint(context, params) {
      return axios.put(`${group + route}/update_point/${params.id}`, params)
    },

    loadSummary(context, pointControlId) {
      return axios.get(`${group + route}/summary_point/${pointControlId}`)
    },

    // adicionar intervalo
    addInterval(context, payload) {
      return axios.post(`${group + route}/add_interval/${payload.pointControlId}`, payload)
    },

    /**
     * finalizar intervalo ou o ponto
     */
    finalizeIntervalOrPoint(context, pointControlId) {
      return axios.get(`${group + route}/finalize_interval_or_point/${pointControlId}`)
    },

    /**
     * carregar atividades do ponto
     */
    loadActivities(context, pointControlId) {
      return axios.get(`${group + route}/load_activities/${pointControlId}`)
    },

    /**
     * deletar ponto
     */
    deletePointControl(context, pointControlId) {
      return axios.delete(`${group + route}/delete_point/${pointControlId}`)
    },

  },

}
